import { useCallback, useEffect, useMemo } from "react";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { ConfigurationItemKind, useConfigurationNavigationApi, useConfigurationNavigationStateExpanded, } from "@plansoft-configuration-renderer/framework";
import { useCurrentLayoutCell } from "@plansoft-configuration-renderer/layout";
import { composeGroupPath } from "../../NavigationState/composeGroupPath";
export function useAttributeGroupExpansionState(options) {
    const { toggleItem } = useConfigurationNavigationApi();
    const { defaultIsOpen, groupId } = options;
    const cell = useCurrentLayoutCell({ visibleLayoutOnly: true });
    const cfgObject = useCsCfgObject();
    const item = useMemo(() => ({
        kind: ConfigurationItemKind.ConfigurationGroup,
        path: composeGroupPath({
            configurationObjectPath: cfgObject.path,
            groupId: groupId,
            cellId: cell === null || cell === void 0 ? void 0 : cell.id,
        }),
        id: groupId,
        cellId: cell === null || cell === void 0 ? void 0 : cell.id,
    }), [cell === null || cell === void 0 ? void 0 : cell.id, cfgObject.path, groupId]);
    const expandedFromState = useConfigurationNavigationStateExpanded(item);
    const setIsExpanded = useCallback((isOpen) => {
        toggleItem(item, isOpen);
    }, [item, toggleItem]);
    // revert to defaultExpanded if the state is initial or reset
    useEffect(() => {
        if (expandedFromState == null) {
            setIsExpanded(defaultIsOpen);
        }
    }, [defaultIsOpen, expandedFromState, setIsExpanded]);
    // we need a fallback to force controlled state
    const isExpanded = expandedFromState !== null && expandedFromState !== void 0 ? expandedFromState : defaultIsOpen;
    return { isExpanded, setIsExpanded };
}
//# sourceMappingURL=useAttributeGroupExpansionState.js.map